import type {Request} from 'express';

const CheckoutAllowedPaths = ['/checkout', '/checkout/express'];

export const isAppCheckoutRequest = (req: Request) => {
  const pathname = req.originalUrl.split('?')[0];

  const isAppCheckout = Boolean(
    pathname &&
      CheckoutAllowedPaths.includes(pathname) &&
      req.query &&
      Boolean(req.query.disableInteractivity),
  );

  return isAppCheckout;
};
